<template>
    <div class="row">
      <div class="col-md-12">
        <b-form @submit.prevent.stop="onSubmit" @reset.prevent.stop="onReset" novalidate="novalidate">
          <div class="card">
            <div class="card-header card-header-icon card-header-rose">
              <div class="card-icon" v-b-toggle.filter>
                <i class="material-icons">search</i>
              </div>
              <h4 class="card-title">Filtros</h4>
            </div>
            <br />
            <b-collapse id="filter">
              <div class="card-body">
                <div class="row">
                    <div class="col-md-8">
                        <div class="form-group bmd-form-group is-filled">
                            <input type="text" placeholder="Buscar por Nome, Marca ou Código." 
                                   name="name" 
                                   v-model="form.name" 
                                   class="form-control" 
                                   id="name" 
                                   autocomplete="off" @input="findDataText(form.name)" />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group bmd-form-group is-filled">
                        <model-list-select
                            class="form-control"
                            :list="items"
                            option-value="id"
                            option-text="name"
                            v-model="form.id"
                            placeholder="Marca"
                            @input="findDataMarca( form.id )"></model-list-select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <button type="reset" class="btn btn-fill btn-outline-danger">Limpar Filtros</button>
                <!-- <button type="submit" class="btn btn-fill btn-rose">Filtrar</button> -->
              </div>
            </b-collapse>
          </div>
        </b-form>
      </div>
    </div>
</template>

<script>
    export default {
      data(){
            return {
                form : {
                    id : null,
                    name : null,
                }
            }
        },
        computed: {
            items: {
                set(_manufacturers) {

                },
                get() {
                    return this.$store.state.manufacturers.itens;
                }
            }
        },
        created(){
          this.getData();
        },
        methods : {
            onReset(e){
                this.form.id   = '';
                this.form.name = '';
                this.$emit('resetFilters');
            },
            findDataText( name ){
              this.form.id = '';
              this.$emit('filterName', name);
            },
            findDataMarca(id){
              this.form.name = '';
              this.$emit('filterMarca', id);
            },
            async getData() {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('manufacturers/all');

                response.then(function () {
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
        }
    }
  }
</script>